import {
  type FontSize,
  type HeadingSize,
  headingSizes,
} from '../text/font-size.ts'

export const isFontSizeHeading = (
  fontSize: FontSize
): fontSize is HeadingSize => headingSizes.includes(fontSize as HeadingSize)
